var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sticker"},[_vm._l((_vm.layers),function(layer,i){return _c('img',{key:i,class:layer.cls,style:('z-index: ' + i),attrs:{"alt":"","src":layer.src}})}),_vm._v(" "),_c('img',{staticClass:"invisible",attrs:{"src":_vm.scaffold,"alt":_vm.alt}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }